/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { IconButton, Button } from "@chakra-ui/react";
import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";

export default function Pagination(props) {
  let {
    totalEntries,
    limit,
    pageRight,
    pageLeft,
    page,
    setPage,
    paginationText,
  } = props;
  let totalPages;

  if (totalEntries % limit === 0) {
    totalPages = totalEntries / limit;
  } else {
    totalPages = Math.ceil(totalEntries / limit);
  }

  function handleClickRight() {
    if (page !== totalPages) {
      setPage(page + 1);
      pageRight();
    }
  }

  function handleClickLeft() {
    if (page !== 1) {
      setPage(page - 1);
    }
  }

  return (
    <nav aria-label="Pagination">
      <IconButton
        aria-label="Page Left"
        bgColor="white"
        variant="outline"
        onClick={() => {
          handleClickLeft();
          pageLeft();
        }}
        icon={<ArrowLeftIcon />}
      />
      <Button
        aria-label="Pages"
        bgColor="white"
        variant="outline"
      >
        {paginationText} {page} of {totalPages}
      </Button>
      <IconButton
        aria-label="Page Right"
        bgColor="white"
        variant="outline"
        onClick={() => {
          handleClickRight();
        }}
        icon={<ArrowRightIcon />}
      />
    </nav>
  );
}
